import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo } from 'react';
import { FaLink, FaTimes } from 'react-icons/fa';
import ModalOverlay from '../ModalOverlay/ModalOverlay';
import { backendUrl } from '@common/contracts';
import './ImageSelectModal.scss';
// Normalizes the image URL by prepending backendUrl when it is not a full URL
const normalizeImageUrl = (url) => {
    if (!url)
        return undefined;
    return url.startsWith('http') ? url : `${backendUrl}${url}`;
};
export const ImageSelectModal = ({ isOpen, onClose, onSelectImage, images, title = "Select Background Image", isImageUsed }) => {
    const [imageFilter, setImageFilter] = useState('all');
    // Filter images by usage status (exactly as in DialogueEditor)
    const filteredImages = useMemo(() => {
        if (imageFilter === 'all')
            return images;
        return images.filter(img => {
            const isUsed = isImageUsed ? isImageUsed(img.imageUrl) : false;
            return imageFilter === 'linked' ? isUsed : !isUsed;
        });
    }, [images, imageFilter, isImageUsed]);
    if (!isOpen)
        return null;
    return (_jsx(ModalOverlay, { onClose: onClose, children: _jsxs("div", { className: "background-select-modal", children: [_jsxs("div", { className: "modal-header", children: [_jsx("h3", { children: title }), _jsxs("div", { className: "filter-controls", children: [_jsx("button", { className: `filter-button ${imageFilter === 'all' ? 'active' : ''}`, onClick: () => setImageFilter('all'), children: "All" }), _jsxs("button", { className: `filter-button ${imageFilter === 'linked' ? 'active' : ''}`, onClick: () => setImageFilter('linked'), children: [_jsx(FaLink, { size: 10 }), " Linked"] }), _jsx("button", { className: `filter-button ${imageFilter === 'unlinked' ? 'active' : ''}`, onClick: () => setImageFilter('unlinked'), children: "Unlinked" })] }), _jsx("button", { className: "modal-close-button", onClick: onClose, title: "Close", children: _jsx(FaTimes, {}) })] }), _jsxs("div", { className: "background-grid", children: [filteredImages.map(img => (_jsx("div", { className: "bg-image-tile", onClick: () => {
                                onSelectImage(normalizeImageUrl(img.imageUrl));
                                onClose();
                            }, children: _jsx("img", { src: normalizeImageUrl(img.imageUrl), alt: img.filename }) }, img.id))), filteredImages.length === 0 && (_jsx("div", { className: "empty-state", children: images.length === 0
                                ? 'No background images uploaded yet.'
                                : `No ${imageFilter} background images found.` }))] })] }) }));
};
